import dynamic from 'next/dynamic'

const componentMap = {
  FlexibleContentFlexibleContentFieldsServicesRepeaterLayout: dynamic(() => import('./ServicesRepeater')),
  FlexibleContentFlexibleContentFieldsAlternatingTextAndImageLayout: dynamic(() => import('./AlternatingContent')),
  FlexibleContentFlexibleContentFieldsFeaturedCaseStudiesBlockLayout: dynamic(() => import('./FeaturedCaseStudies')),
  FlexibleContentFlexibleContentFieldsActionableInsightsBlockLayout: dynamic(() => import('./ActionableInsights')),
  FlexibleContentFlexibleContentFieldsSliderLayout: dynamic(() => import('./Slider'), { ssr: false }),
  FlexibleContentFlexibleContentFieldsTeamPhotoFeedLayout: dynamic(() => import('./TeamPhotoFeed')),
  FlexibleContentFlexibleContentFieldsContentWithPhotoFeedLayout: dynamic(() => import('./ContentwithPhotoFeed')),
  FlexibleContentFlexibleContentFieldsContentWithImagesLayout: dynamic(() => import('./ContentwithImages'), { ssr: false }),
  FlexibleContentFlexibleContentFieldsStandardContentDarkBackgroundLayout: dynamic(() => import('./ContentDarkBackground')),
  FlexibleContentFlexibleContentFieldsIndustryHighlightsLayout: dynamic(() => import('./IndustryHighlights')),
  FlexibleContentFlexibleContentFieldsInstagramfeedLayout: dynamic(() => import('../InstagramFeed'), { ssr: false }),
  FlexibleContentFlexibleContentFieldsBrandBlockLayout: dynamic(() => import('./BrandBlock')),
  FlexibleContentFlexibleContentFieldsContentBlockLayout: dynamic(() => import('./ContentBlock')),
  FlexibleContentFlexibleContentFieldsTwoColumnContentLayout: dynamic(() => import('./TwoColumnContent')),
  FlexibleContentFlexibleContentFieldsJobsfeedLayout: dynamic(() => import('./JobsFeed')),
  FlexibleContentFlexibleContentFieldsVideoCarouselLayout: dynamic(() => import('./VideoCarousel'), { ssr: false }),
  FlexibleContentFlexibleContentFieldsLeaderProfileLayout: dynamic(() => import('./LeaderProfile'))
}

function FlexibleContent(props) {
  const flexibleContent = props.content
  // Lets a page template pass layout-specific props without hardcoding them per page.
  const contentBlockProps = props.contentBlockProps

  if (!Array.isArray(flexibleContent) || flexibleContent.length === 0) {
    return null
  }

  return (
    <>
      {flexibleContent.map((layout, index) => {
        const Component = componentMap[layout.fieldGroupName]
        if (!Component) return null

        let extraProps = {}
        if (layout.fieldGroupName === 'FlexibleContentFlexibleContentFieldsContentBlockLayout' && contentBlockProps) {
          extraProps = contentBlockProps
        }

        if (layout.fieldGroupName === 'FlexibleContentFlexibleContentFieldsInstagramfeedLayout') {
          return <Component key={index} />
        }

        return <Component key={index} fields={layout} {...extraProps} />
      })}
    </>
  )
}

export default FlexibleContent
